<div class="toggle-container" [formGroup]="formGroup">
    <mat-slide-toggle 
        [formControlName]="control.name"
        [hideIcon]="true"
    >
        {{control.displayText}}
    </mat-slide-toggle>
</div>